import React, { useState } from 'react'

import { SingleRestaurantQuery } from '~/generated/graphql'
import { gt } from '~/locale'
import Button from '~/shared/atoms/Button'
import { CarouselContent, CarouselControls, CarouselImage, CarouselItem, CarouselProvider } from '~/shared/molecules/Carousel'

import RestaurantGallery from './RestaurantGallery'
import { ButtonWrapper, RestaurantPageCarouselWrapper, StyledCarouselButton } from './RestaurantPageCarouselShards'

type Restaurant = NonNullable<SingleRestaurantQuery['restaurant']>

export function RestaurantPageCarousel({
  images = [],
  restaurantName,
}: {
  images: Restaurant['imageFiles']
  restaurantName: Restaurant['name']
}) {
  const [showGallery, setShowGallery] = useState(false)
  return (
    <RestaurantPageCarouselWrapper>
      <CarouselProvider autoPlay>
        <CarouselContent>
          {images.map((image, i) => {
            return (
              <CarouselItem key={image.id}>
                <CarouselImage src={image?.profile || image?.preview || image?.original || ''} alt={restaurantName} index={i} />
              </CarouselItem>
            )
          })}
        </CarouselContent>
        <CarouselControls Button={StyledCarouselButton} />
      </CarouselProvider>
      <ButtonWrapper>
        <Button
          label={gt.tp('RestaurantPageCarousel', 'Show all photos')}
          color='secondary'
          height='small'
          onClick={() => setShowGallery(true)}
        />
      </ButtonWrapper>
      <RestaurantGallery images={images} title={restaurantName} show={showGallery} onClose={() => setShowGallery(false)} />
    </RestaurantPageCarouselWrapper>
  )
}
